import CandidatesWrapper from './CandidatesWrapper';

export default CandidatesWrapper;
